/** Khoảng thời gian dùng chung cho Dashboard và trang Truy cập. "all" = từ ngày có dữ liệu đầu tiên tới nay. */
export const TIME_RANGES = [
  { value: 7, label: "7 ngày" },
  { value: 30, label: "30 ngày" },
  { value: 90, label: "90 ngày" },
  { value: "all", label: "Từ đầu" },
];

export const GRANULARITIES = [
  { value: "day", label: "Ngày" },
  { value: "week", label: "Tuần" },
  { value: "month", label: "Tháng" },
];

export const GRANULARITY_UNIT = { day: "ngày", week: "tuần", month: "tháng" };

function parseKey(key) {
  const [y, m, d] = String(key).split("-").map(Number);
  return { y, m, d: d || 1 };
}

const pad2 = (n) => String(n).padStart(2, "0");

export function formatDayKey(key, long) {
  const { y, m, d } = parseKey(key);
  if (!y) return key;
  return long
    ? new Date(y, m - 1, d).toLocaleDateString("vi-VN", { weekday: "long", day: "2-digit", month: "2-digit", year: "numeric" })
    : `${pad2(d)}/${pad2(m)}`;
}

/**
 * Nhãn cho một điểm dữ liệu theo độ chi tiết.
 * - ngày: "14/10" · "Thứ ba, 14/10/2026"
 * - tuần (key = thứ Hai): "13/10" · "Tuần 13/10 – 19/10/2026"
 * - tháng (key = "YYYY-MM"): "T10/26" · "Tháng 10/2026"
 */
export function formatBucket(key, granularity = "day", long = false) {
  const { y, m, d } = parseKey(key);
  if (!y) return key;
  if (granularity === "month") return long ? `Tháng ${m}/${y}` : `T${m}/${String(y).slice(2)}`;
  if (granularity === "week") {
    if (!long) return `${pad2(d)}/${pad2(m)}`;
    const end = new Date(y, m - 1, d + 6);
    return `Tuần ${pad2(d)}/${pad2(m)} – ${pad2(end.getDate())}/${pad2(end.getMonth() + 1)}/${end.getFullYear()}`;
  }
  return formatDayKey(key, long);
}

export function formatFullDate(key) {
  const { y, m, d } = parseKey(key);
  return y ? `${pad2(d)}/${pad2(m)}/${y}` : key;
}

/** "15/04/2026 – 14/10/2026 · 183 ngày" */
export function rangeText(from, to, nDays) {
  return `${formatFullDate(from)} – ${formatFullDate(to)}${nDays ? ` · ${nDays} ngày` : ""}`;
}
